import React, { Component } from 'react';
import { safeParse } from '../utils';
const Parser = safeParse;
import Breadcrumbs from '../block/Breadcrumbs';

class App extends Component {

  render() {
    const data = this.props?.data || {}
    const products = data?.products || []
    const query = data?.query || ''

    return (
      <div className='mt-[95px] xl:mt-[150px] leading-none'>
        <div className='container'>
          <Breadcrumbs breadcrumbs={data?.breadcrumbs} />
          
          <h1 className='font-medium mt-[30px] xl:mt-[40px] tracking-[-0.04em] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start'>
            {Parser(data?.pagetitle)}
          </h1>

          {/* Результаты поиска */}
          {query && (
            <div className='mt-[40px] xl:mt-[50px]'>
              <h2 className='text-[18px] xl:text-[22px] font-medium text-[#032432] mb-[20px]'>
                Результаты поиска по запросу: <span className='text-[#009EE3]'>"{query}"</span>
              </h2>
              
              {products.length > 0 ? (
                <div className='grid grid-cols-2 xl:grid-cols-4 gap-[15px] xl:gap-[20px]'>
                  {products.map((product) => (
                    <a 
                      key={product.id} 
                      href={product.url}
                      className="group leading-none tracking-[-0.04em] no-underline"
                    >
                      <div className='flex items-center justify-center overflow-hidden rounded-[15px] w-full h-[210px] xl:h-[271px] relative'>
                        <div className="absolute top-[15px] right-[15px] xl:top-[20px] xl:right-[20px] w-[30px] h-[30px] xl:w-[35px] xl:h-[35px] rounded-full bg-white flex items-center justify-center text-black text-[18px] leading-none transition-all duration-300 cursor-pointer group-hover:bg-[#009EE3] group-hover:text-white">
                          <svg width="13" height="5" viewBox="0 0 13 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.25209 4.35598C9.40809 3.99598 9.57009 3.67798 9.73809 3.40198C9.90609 3.11398 10.0741 2.86798 10.2421 2.66398H9.39667e-05V1.69198H10.2421C10.0741 1.47598 9.90609 1.22998 9.73809 0.953984C9.57009 0.665984 9.40809 0.347984 9.25209 -1.61529e-05H10.0981C10.8541 0.875984 11.6521 1.52398 12.4921 1.94398V2.41198C11.6521 2.81998 10.8541 3.46798 10.0981 4.35598H9.25209Z" fill="currentColor"/>
                          </svg>
                        </div>
                        <img 
                          src={product.img || 'src/images/catalog_img.png'} 
                          alt={product.name} 
                          width={137} 
                          height={192}
                          className="object-contain rounded-[15px] w-full h-auto"
                        />
                      </div>
                      <div className='mt-[14px] text-[16px] xl:text-[18px] text-[#032432] group-hover:text-[#009EE3] transition-colors break-words hyphens-auto'>
                        {product.name}
                      </div>
                      <div className='mt-[10px] text-[16px] xl:text-[18px] text-[#032432]/60'>
                        {Parser(product.title)}
                      </div>
                      <div className='mt-[2px] text-[14px] xl:text-[16px] text-[#032432]/60 break-all'>
                        {Parser(product.text)}
                      </div>
                    </a>
                  ))}
                </div>
              ) : (
                <div className='text-center text-[#032432]/60 text-[18px] py-[40px]'>
                  По вашему запросу товары не найдены
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default App